import { DefaultLayout } from "@imminently/react/ui/outlets/layouts/default";

import { AppHeader } from "./AppHeader";
import { css } from "@/theme";
import { Outlet } from "react-router";
import { useSettingsContext } from "@/pages/settings/SettingsProvider";
import { AppLoading } from "@/pages/app-loading";

const styles = {
  layout: css`
    .defaultLayout-body {
      position: relative;
      // full screen - header height
      height: calc(100vh - 57px);
    }
  `,
};

const header = <AppHeader />;

export const AppLayout = () => {
  const settings = useSettingsContext();

  // add the loading states here, as we are past auth, but might need other information
  // before we can render the app
  if (settings.settings === undefined) {
    return <AppLoading />;
  }

  return (
    <DefaultLayout css={styles.layout} header={header}>
      {/* <AppSidebar /> */} {/* Disabled for now */}
      <Outlet />
    </DefaultLayout>
  );
};
